export default __webpack_public_path__ + "static/media/SD-divider.58f0d009.svg";